import axios from 'axios'
const { VUE_APP_API_URL } = process.env

const fetchCategories = async (country) => {
  try {
    const rnd = Math.random()
    const res = await axios
      .get(`${VUE_APP_API_URL}/api/etrail/question-categories/${country}?rnd=${rnd}`)
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

const fetchAreas = async (country, category) => {
  try {
    const rnd = Math.random()
    const res = await axios
      .get(`${VUE_APP_API_URL}/api/etrail/question-area-by-categories/${country}/${category}?rnd=${rnd}`)
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

const fetchQuestions = async (country, category, area) => {
  try {
    const rnd = Math.random()
    const res = await axios
      .get(`${VUE_APP_API_URL}/api/etrail/questions-by-area/${country}/${category}/${area}?rnd=${rnd}`)
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

export {
  fetchCategories, fetchAreas, fetchQuestions
}
